var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLargeArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 25 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.368 23.93 1.107 1.08 11.903-12.02L12.342.977l-1.1 1.086L21.42 12.227H.378v1.54h21.05L11.369 23.93Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLargeArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LargeArrowRight.cb08f4571fb224d24e0931aa8577b063.svg";